// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"Gm","place_order_copy":"Hm","next_order_copy":"Im","title_wrapper":"Jm","get_it_now_row":"Km","get_it_now_remaining_items":"Lm","get_it_now_remaining_items_mob":"Mm","order_summary":"Nm","additional_items":"Om","account_content_slider":"Pm","ingredient_carousel":"Qm","ingredient_carouselwrapper":"Rm","account_content_slide":"Sm","account_subscription_section_mob":"Tm","carouselwrapper":"Um"};
    if(module.hot) {
      // 1743628918759
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  